import { Preloader } from '@cian/components';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { ComplaintBlockType, IComplaint, TComplaintBlockType } from '../../api/complaint';
import { getLastArrayItem, isArrayWithItems } from '../../utils';
import { getCustomUrl } from '../../utils/tracking';
import * as styles from './index.css';
import { ComplaintItemContainer } from './item/container';
import { EFeedbackComplaint } from '../../store/complaint/feedback_complaint';
import { ComplaintFeedbackFormContainer } from './feedback_form/container';
import { trackSubmitComplaint } from './item/tracking';

export interface IComplaintProps {
  complaints: IComplaint[] | null;
  errorMessage: string | null;
  isComplaintAdded: boolean;
  isLoading: boolean;
  offer: IOfferSchema;
  sendFeedbackStatus: EFeedbackComplaint;
  agent: IAgentSchema | null;

  getComplaints(category: number): void;
  resetComplaintState(): void;
  handleOutsideClick(): void;
  statusChanger(status: EFeedbackComplaint): void;
}

interface IComplaintState {
  selectionTree: number[];
  selected: number | undefined;
}

export class Complaint extends React.PureComponent<IComplaintProps, IComplaintState> {
  public state = {
    selected: undefined,
    selectionTree: [] as number[],
  };

  public UNSAFE_componentWillReceiveProps(nextProps: IComplaintProps) {
    if (nextProps.sendFeedbackStatus === EFeedbackComplaint.success) {
      this.props.statusChanger(EFeedbackComplaint.default);
      this.props.handleOutsideClick();
    }
  }

  public UNSAFE_componentWillMount() {
    this.props.resetComplaintState();
  }

  public componentDidMount() {
    const { getComplaints, offer } = this.props;

    if (!isArrayWithItems(offer.categoriesIds)) {
      return;
    }

    const categoryId = getLastArrayItem<number>(offer.categoriesIds);

    if (categoryId) {
      getComplaints(categoryId);
    }
  }

  public render() {
    const {
      complaints,
      errorMessage,
      isComplaintAdded,
      isLoading,
      sendFeedbackStatus,
      handleOutsideClick,
    } = this.props;
    const { selectionTree } = this.state;

    if (isComplaintAdded && sendFeedbackStatus !== EFeedbackComplaint.success) {
      return <ComplaintFeedbackFormContainer handleOutsideClick={handleOutsideClick} />;
    }

    if (isLoading) {
      return (
        <div {...mergeStyles([styles['container'], styles['preloader-wrapper']])}>
          <Preloader size={50} />
        </div>
      );
    }

    if (!isArrayWithItems(complaints)) {
      return null;
    }

    if (errorMessage) {
      return (
        <div className={styles['container']} onClick={this.handleClickOnContainer}>
          {errorMessage}
        </div>
      );
    }

    const selectedComplaint = this.getSelectedComplaint();
    const selectedComplaints = (selectedComplaint && selectedComplaint.items) || complaints;

    return (
      <div className={styles['container']} onClick={this.handleClickOnContainer}>
        {selectionTree.length > 0 && (
          <button className={styles['back']} onClick={this.handleClickOnPrevButton}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.925 10" width="6" height="10">
              {/* tslint:disable-next-line:max-line-length */}
              <path
                fill="currentColor"
                d="M.29 4.342L4.297.182c.474-.324 1.12-.204 1.446.27.23.334.244.77.037 1.12L2.495 5.06 5.78 8.43c.29.496.126 1.134-.37 1.425-.347.203-.78.19-1.113-.038L.29 5.66C.13 5.496.03 5.287 0 5.062c0-.27.104-.527.29-.72z"
              />
            </svg>
          </button>
        )}
        <h3 className={styles['title']}>
          Шаг {selectionTree.length + 1}. {!selectedComplaint ? 'На что жалуетесь?' : selectedComplaint.title}
        </h3>
        <ul className={styles['links']}>
          {selectedComplaints.map((complaint, index) => (
            <ComplaintItemContainer
              index={index}
              onSelect={this.handleSelect}
              isSelected={this.state.selected === index}
              complaint={complaint}
              key={`complaint-${complaint.id}`}
            />
          ))}
        </ul>
      </div>
    );
  }

  private handleClickOnContainer = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  private handleSelect = (index: number, blockType?: TComplaintBlockType, url?: string) => {
    const { agent, offer } = this.props;

    if (this.state.selected === index) {
      return;
    }

    if (blockType === ComplaintBlockType.Textarea) {
      this.setState({ selected: index });

      return;
    } else if (blockType === ComplaintBlockType.Link) {
      const objectUrl = window.location.href;

      trackSubmitComplaint(getCustomUrl(offer, agent));
      window.open(objectUrl ? `${url}&object_url=${objectUrl}` : url, '_blank');

      return;
    }

    this.setState({
      selected: undefined,
      selectionTree: this.state.selectionTree.concat(index),
    });
  };

  private getSelectedComplaint(): IComplaint | undefined {
    const { complaints } = this.props;
    let selectedComplaint: IComplaint | undefined;

    if (!isArrayWithItems(complaints)) {
      return undefined;
    }

    this.state.selectionTree.forEach(complaintIndex => {
      selectedComplaint = (selectedComplaint && selectedComplaint.items[complaintIndex]) || complaints[complaintIndex];
    });

    return selectedComplaint;
  }

  private handleClickOnPrevButton = () => {
    this.setState({
      selected: undefined,
      selectionTree: this.state.selectionTree.slice(0, this.state.selectionTree.length - 1),
    });
  };
}
